/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class FinAiAgentSalesAnalyzeMonitorRoute extends Route {
  queryParams = {
    interval: { refreshModel: false },
  };

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.sales.analyze.monitor',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(FinAiAgentSalesAnalyzeMonitorRoute, {
  overrideRenderTemplate: false,
});
